import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Typography } from '@material-ui/core';
import Seo from '../Seo/Seo';

class Schedule extends Component {

    render() {

        return (

            <div style={{ marginTop: 70, padding: 30 }}>
                <Seo
                    title="Trivia Schedule | Trivia Weekend"
                    description="Plan shifts and key events with the Trivia Weekend schedule view."
                    canonicalPath="/#/schedule"
                    ogType="website"
                />
                <Typography variant="h4" component="h1" style={{ marginBottom: 12 }}>
                    Trivia Schedule
                </Typography>
                <Typography variant="body1">
                    Plan your trivia marathon shifts, breaks, and critical moments here.
                </Typography>
            </div>
        )

    }

}

const mapStateToProps = state => ({
    user: state.user,
});
export default withRouter(connect(mapStateToProps)(Schedule));
